import { render, staticRenderFns } from "./contactUsList.vue?vue&type=template&id=0ebd4565&scoped=true"
import script from "./contactUsList.vue?vue&type=script&lang=js"
export * from "./contactUsList.vue?vue&type=script&lang=js"
import style0 from "./contactUsList.vue?vue&type=style&index=0&id=0ebd4565&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebd4565",
  null
  
)

export default component.exports